import { RuntimeEngine, SelectManager } from '@easytwin/runtime';
import { useBindSignal } from './useBindSignal';
import { useDumbState } from './useDumbState';
import { useMainScene } from './useMainScene';

export const useGetSelectedEntities = (engine: RuntimeEngine | undefined) => {
  const refresh = useDumbState();
  const scene = useMainScene(engine);
  const selectManager = scene?.getManager(SelectManager);
  useBindSignal(selectManager?.signals.selectedEntitiesUpdated, refresh);

  console.log('----------', selectManager?.selectedEntities);

  return selectManager?.selectedEntities;
};
